import marked from "marked";
import parse from "html-react-parser";
import { UCMFetch, Logger } from "../../utils/index";

// RCL Implementation
class RCLService {
	constructor(apiUrl, spaceid, appCode) {
		this._apiUrl = apiUrl;
		this._spaceid = spaceid;
		this._appCode = appCode;
		this._dictionaries = {};
		this._getContentFetch = null;
	}

	async getContent({ lang = "en" }) {
		// Only retrieve from Contentful if we do not have it already
		if (Object.keys(this._dictionaries).includes(lang)) {
			return this._dictionaries;
		}
		this._getContentFetch = new UCMFetch(this._apiUrl);
		const payload = {
			lang: [lang],
			spaceid: this._spaceid,
			contenttype: ["applicationResources"],
			fieldstoretrieve: ["value", "key", "parseAsMarkdown"],
			textmatchconditions: [
				{
					"applicationarr.application3charCode": this._appCode
				}
			]
		};
		Logger.info(
			"Retrieving Contentful Content",
			`Calling DCIS API ${this._apiUrl}`,
			payload
		);
		const response = await this._getContentFetch.post({
			payload
		});
		Logger.info(
			"Retrieving Contentful Content",
			`Received ${response.status} response for DCIS API ${this._apiUrl}`
		);
		// console.log(response);
		if (response.ok) {
			this._dictionaries[lang] = RCLService._parseKeyValue(response.body);
			return this._dictionaries;
		}

		return this._dictionaries[lang];
	}

	// Parse data into hash table dictionary
	static _parseKeyValue(data) {
		const _dictionary = {};
		// Eliminate requests for value when locale is not available yet
		if (Object.keys(data).length > 0 && data.constructor === Object) {
			// Ensure that data is available to search for key / value pair
			if (
				data.itemcount &&
				data.itemcount > 0 &&
				data.items.constructor === Array
			) {
				Object.keys(data.items).forEach(index => {
					const item = data.items[index];
					if (item.parseAsMarkdown) {
						_dictionary[item.key] = {
							richCopy: item.value
						};
					} else {
						_dictionary[item.key] = {
							copy: item.value
						};
					}
				});
			}
		}
		return _dictionary;
	}

	// Get value from dictionary table
	value(lang, key) {
		try {
			const dictionaryItem = this._dictionaries[lang][key];

			if (dictionaryItem) {
				if (dictionaryItem.richCopy !== undefined) {
					const _value = marked(dictionaryItem.richCopy, {
						breaks: true
					});

					return parse(_value);
				}
			}

			return dictionaryItem.copy;
		} catch (e) {
			console.warn(`Cannot find '${key}' in the dictionary.`);
			return key;
		}
	}
}

export default RCLService;
export { RCLService };
